
<div class="heading relative">
  <div [class.hidden]="!hasDynamic.header">
    <ng-container #headerComponentContainer></ng-container>
  </div>
  <ng-container *ngIf="!hasDynamic.header">
    <ng-container *ngTemplateOutlet="defaultHeader"></ng-container>
  </ng-container>
</div>

@if(preview){
<div class="w-full relative">
  <ng-container *ngIf="{info: courseInfo$ | async} as course">
    @if(course.info?.status === 'draft'){
      <div class="w-full p-2 text-center bg-slate-800 text-white" i18n>Your course has updates in the draft version. Click <span (click)="notificationAction('resume-editing', course.info)" class="text-primary-500 cursor-pointer underline">Resume Editing</span> to review.</div>
    }@else if(course.info?.status === 'rejected'){
      <div class="w-full p-2 text-center bg-red-100 text-red-700" i18n>Your submitted version was rejected. Click <span (click)="notificationAction('view-published-version', course.info)" class="underline font-semibold cursor-pointer">View Rejected Version</span> to review feedback and make updates.</div>
    }@else if(course.info?.status === 'in_review'){
      <div class="w-full p-2 text-center bg-warning-100 text-warning-800" i18n>You’re viewing the published version. A newer version is under review. Click <span (click)="notificationAction('view-published-version', course.info)" class="underline font-semibold cursor-pointer">View Under Review</span> to check it out or Withdraw Submission.</div>
    }
  </ng-container>
</div>
}
<div class="instructor-shell flex overflow-y-auto overflow-x-hidden">
  <div [ngClass]="showSidebar ? 'w-[266px] lg:w-0':'w-0 lg:w-[266px]'" class="flex-none overflow-hidden transition-all" [class.hidden]="hideSidebar">
    <div [class.hidden]="!hasDynamic.sidebar" class="h-full">
      <ng-container #sidebarComponentContainer></ng-container>
    </div>
    <ng-container *ngIf="!hasDynamic.sidebar">
      <ng-container *ngTemplateOutlet="defaultSidebar"></ng-container>
    </ng-container>
  </div>
  <div class="grow w-full">
    <div class="router-content overflow-auto">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<ng-template #defaultSidebar>
  <app-instructor-sidebar></app-instructor-sidebar>
</ng-template>

<ng-template #defaultHeader>
  <app-instructor-header (toggleSidebar)="toggleSidebar($event)" [fullSize]="hideSidebar"></app-instructor-header>
</ng-template>
